/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTipoCuentaBancariaVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTipoCuentaBancaria: React.FunctionComponent<ITablaTipoCuentaBancariaVistaProps & InjectedIntlProps> = ({
    tipoCuentaBancarias,
    cargarTipoCuentaBancaria,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tipoCuentaBancarias}
            actions={acciones(manejarFormulario, cargarTipoCuentaBancaria, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTipoCuentaBancaria);
